import { ListItemText } from '@material-ui/core';
import React, { useCallback } from 'react';
import { isNullOrUndefined } from '../../utils/isNullOrUndefined';
import {
  BaseSelect,
  BaseSelectOption,
  BaseSelectProps,
  SelectValue,
  Value,
} from './BaseSelect';

export type SelectOption = BaseSelectOption & {
  label: string | React.ReactNode;
};

function SingleValueDisplay({
  value,
  options,
}: {
  value: SelectValue;
  options: SelectOption[];
}) {
  const optLabel = options.find((opt) => opt.value === value)?.label;
  if (!optLabel) return null; // mostly for ts

  return <Value $isString={typeof optLabel === 'string'}>{optLabel}</Value>;
}

type SelectProps = Omit<
  BaseSelectProps<SelectOption>,
  'multiple' | 'renderOption' | 'renderValue'
>;

/** functions as a SingleSelect. If multiple options can be picked, use MultiSelect */
export function Select(props: SelectProps) {
  const { options, value } = props;

  const renderValue = useCallback(
    (val) => <SingleValueDisplay value={val} options={options} />,
    [options],
  );

  const renderOption = useCallback(
    (option: SelectOption) =>
      option.subText ? (
        <ListItemText primary={option.label} secondary={option.subText} />
      ) : (
        option.label
      ),
    [],
  );

  return (
    <BaseSelect
      {...props}
      isEmpty={isNullOrUndefined(value)}
      renderValue={renderValue}
      renderOption={renderOption}
    />
  );
}
